import { AxiosResponse } from 'axios';
import {
  ICriticalIncident,
  ICriticalIncidentsParams,
  IPaymentDiagnostics,
  IPaymentPaginated,
  IPaymentWebhookRequest,
  IResolveIncidentsResponse,
  IWebhookRequestsParams,
} from 'common/types/payment-diagnostics';

import { $host } from './index';

const BASE_URL = 'admin/payment-diagnostics';

export const getDiagnosticsByOrderId = async (orderId: number) => {
  const {
    data: { data },
  } = await $host.get<AxiosResponse<IPaymentDiagnostics>>(
    `${BASE_URL}/orders/${orderId}`,
  );

  return data;
};

export const getDiagnosticsByAttemptId = async (attemptId: number) => {
  const {
    data: { data },
  } = await $host.get<AxiosResponse<IPaymentDiagnostics>>(
    `${BASE_URL}/attempts/${attemptId}`,
  );

  return data;
};

export const getDiagnosticsByIntentId = async (providerIntentId: string) => {
  const {
    data: { data },
  } = await $host.get<AxiosResponse<IPaymentDiagnostics>>(
    `${BASE_URL}/intents/${encodeURIComponent(providerIntentId)}`,
  );

  return data;
};

export const getCriticalIncidents = async (
  params?: ICriticalIncidentsParams,
) => {
  const {
    data: { data },
  } = await $host.get<AxiosResponse<IPaymentPaginated<ICriticalIncident>>>(
    `${BASE_URL}/incidents/critical`,
    { params },
  );

  return data;
};

export const resolveIncidents = async (ids: number[], reason?: string) => {
  const {
    data: { data },
  } = await $host.post<AxiosResponse<IResolveIncidentsResponse>>(
    `${BASE_URL}/incidents/resolve`,
    { ids, reason: reason?.trim() || undefined },
  );

  return data;
};

export const getWebhookRequests = async (params?: IWebhookRequestsParams) => {
  const {
    data: { data },
  } = await $host.get<
    AxiosResponse<IPaymentPaginated<IPaymentWebhookRequest>>
  >(`${BASE_URL}/webhook-requests`, { params });

  return data;
};
